// extracted by mini-css-extract-plugin
export var cardLayout = "_6e-1";
export var paginationContainer = "_6e-0";